


























































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import AbpBase from "../lib/abpbase";
@Component
export default class DatePicker extends AbpBase {
  weeks: Array<string> = [this.L("MON"), this.L("TUE"), this.L("WED"),this.L("THUR"),this.L("FRI"), this.L("SAT"), this.L("SUN")];
  monthDays: Array<any> = [];
  async created() {
    var list = await this.$store.dispatch({
      type: "appointment/getDailyList",
      data: { index: 0 },
    });
    this.monthDays = list.meetingAppointmentDailyDtos;

    this.$emit("set", { currentMonth:list.currentMonth ,index : list.index, month: list.date });
  }

  async freshCalendar(index) {
    var list = await this.$store.dispatch({
      type: "appointment/getDailyList",
      data: { index: index },
    });
    this.monthDays = list.meetingAppointmentDailyDtos;

    this.$emit("set", { currentMonth:list.currentMonth ,index : list.index, month: list.date });
  }
  chooseDay(item) {
    if (!item.isCurrentMonth) return;
    this.monthDays.map((x) => {
      x.isClick = false;
    });
    item.isClick = true;
  }
  clickDay(item) {
    if (!item.isCurrentMonth) return;
    this.$emit("check", item);
  }
}
